
  $(".navbar-toggler").on('click', function() {
    $("html").toggleClass("nav-open");
        });
        //=============================================================================
        $('.form-control').on("focus", function() {
    $(this).parent('.input-group').addClass("input-group-focus");
        }).on("blur", function() {
    $(this).parent(".input-group").removeClass("input-group-focus");
        });



function toggleRightMenubackground() {
  var result = $("#body").hasClass("menu_dark");
  if (result) {
    $("#body").removeClass("menu_dark");
  } else {
    $("#body").addClass("menu_dark");
  }
}

function ToggleRightMenu() {
  var result = $("#body").hasClass("ls-toggle-menu");
  if (result) {
    $("#body").removeClass("ls-toggle-menu");
  } else {
    $("#body").addClass("ls-toggle-menu");
  }
}



// WEBPACK FOOTER //
// src/assets/js/CustomerScript.js